import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent  {

  @Input() title: string;
  @Input() items: any[];
  @Input() active_item: string;

    constructor(private readonly location: Location) {
  }
    onBackButtonClick(): void {
        this.location.back();
    }
  

}
